<template>
  <div 
    v-bind="$attrs" 
    class="we-header w-full flex justify-between items-center" 
    :class="headerClasses"
    :style="headerBgColor"
  >
    <img :src="logo" :class="target !== 'business' ? 'w-32' : 'w-24 lg:w-36'">
  </div>
</template>

<script setup>
  import { computed } from 'vue'
  import { useScreen } from '@/composables'

  import brandLogo from "@/assets/images/brand-logo.svg"
  import businessLogo from "@/assets/images/business-logo.svg"

  const props = defineProps({
    target: {
      type: String,
      default: undefined
    },
    small: {
      type: Boolean,
      default: false
    }
  })

  const { isSmall } = useScreen()

  const logo = computed(()=>{
    return props.target == "business" ? businessLogo : brandLogo
  })

  const headerBgColor = computed(() => {
    if(props.target == "business"){
      return 'background-color: #FFFFFF'
    } else {
      return isSmall.value ? 'background-color: #F0E500' : 'background: linear-gradient(to right, #fff 50.01%, #F0E500 49.99%)'
    }  
  })

  const headerClasses = computed(() => {
    if (props.target === 'business') {
      return props.small
        ? 'px-6 md:px-12 pt-6 pb-4 desktop-layout__header md:border-b border-[#DCDCDC]'
        : 'pb-20 py-10 md:pb-8 lg:pb-10 px-6 md:px-24 desktop-layout__header md:border-b border-[#DCDCDC]'
    }

    return props.small
      ? 'px-6 md:px-12 py-6 desktop-layout__header'
      : 'pb-20 py-10 md:pb-10 px-6 md:px-24 desktop-layout__header'
  })

</script>

<style lang="scss" scoped>

</style>